"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCreateTokenGovernance = void 0;
var web3_js_1 = require("@solana/web3.js");
var serialisation_1 = require("./serialisation");
var borsh_1 = require("borsh");
var instructions_1 = require("./instructions");
var runtime_1 = require("../tools/sdk/runtime");
var splToken_1 = require("../tools/sdk/splToken");
var withRealmConfigPluginAccounts_1 = require("./withRealmConfigPluginAccounts");
var constants_1 = require("../registry/constants");
var withCreateTokenGovernance = function (instructions, programId, programVersion, realm, governedToken, config, transferAccountAuthorities, tokenOwner, tokenOwnerRecord, payer, governanceAuthority, voterWeightRecord) { return __awaiter(void 0, void 0, void 0, function () {
    var args, data, _a, governanceAddress, keys;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                args = new instructions_1.CreateTokenGovernanceArgs({
                    config: config,
                    transferTokenOwner: transferAccountAuthorities,
                });
                data = Buffer.from((0, borsh_1.serialize)((0, serialisation_1.getGovernanceInstructionSchema)(programVersion), args));
                return [4 /*yield*/, web3_js_1.PublicKey.findProgramAddress([
                        Buffer.from('token-governance'),
                        realm.toBuffer(),
                        governedToken.toBuffer(),
                    ], programId)];
            case 1:
                _a = __read.apply(void 0, [_b.sent(), 1]), governanceAddress = _a[0];
                keys = [
                    {
                        pubkey: realm,
                        isWritable: false,
                        isSigner: false,
                    },
                    {
                        pubkey: governanceAddress,
                        isWritable: true,
                        isSigner: false,
                    },
                    {
                        pubkey: governedToken,
                        isWritable: true,
                        isSigner: false,
                    },
                    {
                        pubkey: tokenOwner,
                        isWritable: false,
                        isSigner: true,
                    },
                    {
                        pubkey: tokenOwnerRecord,
                        isWritable: false,
                        isSigner: false,
                    },
                    {
                        pubkey: payer,
                        isWritable: true,
                        isSigner: true,
                    },
                    {
                        pubkey: splToken_1.TOKEN_PROGRAM_ID,
                        isWritable: false,
                        isSigner: false,
                    },
                    {
                        pubkey: runtime_1.SYSTEM_PROGRAM_ID,
                        isWritable: false,
                        isSigner: false,
                    },
                ];
                if (programVersion === constants_1.PROGRAM_VERSION_V1) {
                    keys.push({
                        pubkey: web3_js_1.SYSVAR_RENT_PUBKEY,
                        isWritable: false,
                        isSigner: false,
                    });
                }
                keys.push({
                    pubkey: governanceAuthority,
                    isWritable: false,
                    isSigner: true,
                });
                return [4 /*yield*/, (0, withRealmConfigPluginAccounts_1.withRealmConfigPluginAccounts)(keys, programId, realm, voterWeightRecord)];
            case 2:
                _b.sent();
                instructions.push(new web3_js_1.TransactionInstruction({
                    keys: keys,
                    programId: programId,
                    data: data,
                }));
                return [2 /*return*/, governanceAddress];
        }
    });
}); };
exports.withCreateTokenGovernance = withCreateTokenGovernance;
//# sourceMappingURL=withCreateTokenGovernance.js.map